// tslint:disable-next-line: no-unused-expression
import moment from "moment";
import { db } from "../utility/crewbid-db";
import { TblBidDataDisplay } from "../../shared/models/BidDataDisplay";
import * as _ from "lodash";
import { TblPreset } from "../models/TblPreset";
import { TblStatePresetVersionInfo } from "../models/StatePresetVersionInfo";
import { TblBidList } from "../models/TblBidList";
import { IBidDataFile } from "../models/IBidDataFile";
import { AppSettings } from "../models/UserData";
import { TblASortData } from "../models/TblASortData";
import { Injectable } from "@angular/core";
import { FAListData } from "../models/TblFAList";

@Injectable()
export class DexieOperations {
  // tslint:disable-next-line: jsdoc-format
  /**CRUD operation for dexie db */
  dbopen = true;
  constructor() {
    db.open().then(() => {
      this.dbopen = true;
    });
  }
  /* -------------------------------- #region  Fetching dexie data -------------------------------- */
  /**
   * @method getAllDownloadedBid for fetching the downloaded bid data
   * @param empnum as string
   * @param callback for response
   */
  public async getAllDownloadedBid(empnum, callback) {
    db.transaction("rw?", db.BidDataDisplay, async () => {
      callback(
        await db.BidDataDisplay.where("EmpNum").equals(empnum).toArray()
      );
      // await db.BidDataDisplay.where('EmpNum').equals(empnum).toArray().then((response) => {
      // data = [data, ...response]
      // }).catch(error => {
      // callback(null);
      // })
      // }).then(()=> {
      // callback(data);
      // }).catch(err => {
      // callback(null)
      // });
    });
  }

  /**
   * @method getUserInfo for getting user information
   * @param empnum is employee number as string
   * @param callback is callback
   */
  public async getUserInfo(empnum, callback) {
    db.transaction(
      "rw?",
      db.BidDataDisplay,
      db.BidListData,
      db.StatePresetVersionInfo,
      db.Preset,
      db.UserData,
      async () => {
        callback(await db.UserData.where("empId").equals(empnum).toArray());
      }
    );
  }

  /**
   * @method getColumnDefinition for fetching theselected column definition
   * @param empnum as string
   * @param callback for response
   */
  public async getColumnDefinition(empnum, callback) {
    db.transaction(
      "rw?",
      db.BidDataDisplay,
      db.UserData,
      db.INI_ColumnDefinitions,
      async () => {
        callback(
          await db.INI_ColumnDefinitions.where("empNum")
            .equals(empnum)
            .toArray()
        );
      }
    );
  }

    /**
   * @method getVacColumnDefinition for fetching theselected column definition
   * @param empnum as string
   * @param callback for response
   */
    public async getVacColumnDefinition(empnum, callback) {
      db.transaction(
        "rw?",
        db.BidDataDisplay,
        db.UserData,
        db.INI_VacColumnDefinitions,
        async () => {
          callback(
            await db.INI_VacColumnDefinitions.where("empNum")
              .equals(empnum)
              .toArray()
          );
        }
      );
    }

  /**
   * @method getCurrentBidData for fetching currently opened bid details
   * @param empId is employee number as string
   * @param combinationkey is bid id as string
   * @param callback for response
   */
  public getCurrentBidData(empId, combinationkey, callback) {
    try {
      if (db.open) {
        db.transaction(
          "rw?",
          db.BidDataDisplay,
          db.BidListData,
          db.UserData,
          db.StatePresetVersionInfo,
          db.Preset,
          async () => {
            if (empId) {
              callback(
                await db.BidDataDisplay.where("fieldId")
                  .equals(combinationkey)
                  .and((x) => x.EmpNum == empId)
                  .toArray()
              );
            }
          }
        );
      }
    } catch (error) {/* */}
  }

  /**
   * @method getStatePresetVersionInfo for fetching state and preset version
   * @param empId is employee number as string
   * @param key is bid id as string
   * @param callback for response
   */
  public async getStatePresetVersionInfo(empId: number, key: string, callback) {
    if (db.open()) {
      await db
        .transaction("rw?", db.StatePresetVersionInfo, async () => {
          const versionData = await db.StatePresetVersionInfo.where("empId")
            .equals(empId)
            .and((versionInfo) => versionInfo.fileid == key)
            .first();
          callback(versionData);
        })
        .then(() => {
          console.log("Transaction Completed");
        })
        .catch((error) => {
          console.log(`getStatePresetVersionInfo : ${error.stack}`);
        });
    }
  }

  /**
   * @method getPresetData for getting the preset data
   * @param empId is employee id
   * @param position is bid position as string
   * @param callBack for response
   */
  public async getPresetData(empId: number, position: string, callBack) {
    if (db.open()) {
      await db
        .transaction("rw?", db.Preset, async () => {
          //let presetDatas;
          const presetDatas = await db.Preset.where("empId").equals(empId).toArray();
          // if (position == "FA") {
          //   presetDatas = await db.Preset.where("empId")
          //     .equals(empId)
          //     .and((x) => x.position == position)
          //     .toArray();
          // } else {
          //   presetDatas = await db.Preset.where("empId")
          //     .equals(empId)
          //     .and((x) => x.position !== "FA")
          //     .toArray();
          // }
          callBack(presetDatas);
        })
        .then(() => {
          console.log("Transaction Completed");
        })
        .catch((error) => {
          console.log(`getPresetData : ${error.stack}`);
        });
    }
  }

  /**
   * @method getBidListData for getting the bid list data
   * @param empNum is employee number as integer
   * @param key is field id as string
   * @param callBack for response
   */
  public async getBidListData(empNum: number, key: string, callBack) {
    if (db.open()) {
      let bidListDatas;
      await db
        .transaction(
          "rw!",
          db.BidDataDisplay,
          db.UserData,
          db.BidListData,
          async () => {
            bidListDatas = await db.BidListData.where("empNum")
              .equals(empNum)
              .and((x) => x.fieldId == key)
              .toArray();
            callBack(bidListDatas);
          }
        )
        .then(() => {
          console.log("Transaction Completed");
        })
        .catch((error) => {
          console.log(`getBidListData : ${error.stack}`);
        });
    }
  }

  /**
   * @method getBidReceipt for getting the submitted bid data
   * @param submittedBy is submitted by employee number as string
   * @param submittedFor is submitted for employee number as string
   * @param callBack for response
   */
  public async getBidReceipt(
    submittedBy: string,
    submittedFor?: string,
    callBack?
  ) {
    if (this.dbopen) {
      db.transaction("rw?", db.UserBidReceipt, async () => {
        let recordToReturn;
        if (submittedFor) {
          recordToReturn = await db.UserBidReceipt.where("submittedBy")
            .equals(submittedBy)
            .and((x) => x.submittedFor == submittedFor)
            .toArray();
        } else {
          recordToReturn = await db.UserBidReceipt.where("submittedBy")
            .equals(submittedBy)
            .toArray();
        }
        if (recordToReturn !== undefined) {
          callBack(recordToReturn);
        } else {
          callBack(null);
        }
      });
    }
  }

  /**
   * @method getFAList for getting the fa list data
   * @param employeeId is employee number as string
   * @param callBack for response
   */
  public async getFAList(employeeId: string, callBack) {
    if (this.dbopen) {
      db.transaction("rw?", db.FAListData, async () => {
        const recordToReturn = await db.FAListData.where("employeeId")
          .equals(employeeId)
          .first();
        if (recordToReturn !== undefined) {
          callBack(recordToReturn);
        } else {
          callBack(null);
        }
      });
    }
  }

  /**
   * @method getDataForViewFile for getting the file content
   * @param callBack for response
   */
  public async getDataForViewFile(callBack) {
    if (db.open()) {
      await db.transaction("rw?", db.CrewbidFiles, async () => {
        await db.CrewbidFiles.toArray().then((result) => {
          callBack(result);
        });
      });
    }
  }

  /**
   * @method getFlightData for getting flight data
   * @param fileName is filght data file name as string
   * @param callback for reponse
   */
  public getFlightData(fileName: string, callback) {
    let flightData = null;
    try {
      if (db.open()) {
        db.transaction("rw?", db.FlightDataMaster, () => {
          const record = db.FlightDataMaster.where("flightDataName")
            .equals(fileName)
            .first();
          if (record) {
            db.FlightDataMaster.where("flightDataName")
              .equals(fileName)
              .first()
              .then((data) => {
                //callback(data)
                flightData = data;
              })
              .catch((error) => {
                callback(null);
              });
          }
        })
          .then(() => {
            // Transaction completed
            callback(flightData);
          })
          .catch((err) => {
            // transaction error
            callback(null);
          });
      }
    } catch {
      callback(null);
    }
  }

  /**
   * @method getBidFiles for getting the bid files from dexie db
   * @param empId is empoyee number as integer
   * @param key is combination key as string
   * @param callBack is response
   */
  public async getBidFiles(empId: number, key: string, callBack) {
    if (this.dbopen) {
      db.transaction("r", db.BidFileNames, async () => {
        const recordToReturn = await db.BidFileNames.where("fieldId")
          .equals(key)
          .and((x) => x.empId == empId)
          .first();
        if (recordToReturn !== undefined) {
          callBack(recordToReturn);
        } else {
          callBack(null);
        }
      });
    }
  }

  /**
   * @method getASortData for getting the A Sort data
   * @param empNum is employee number as integer
   * @param key is field id as string
   * @param callBack for response
   */
  public async getASortData(empNum: number, key: string, callBack) {
    if (db.open()) {
      let ASortDatas;
      await db
        .transaction("rw!", db.ASortData, async () => {
          ASortDatas = await db.ASortData.where("empNum")
            .equals(empNum)
            .and((x) => x.fieldId == key)
            .toArray();
          callBack(ASortDatas);
        })
        .then(() => {
          console.log("Transaction Completed");
        })
        .catch((error) => {
          console.log(`getASortData : ${error.stack}`);
        });
    }
  }

    /**
   * @method getCommutFlghtChanges for getting the Commute flight change file content
   * @param callBack for response
   */
     public async getCommutFlghtChanges(callBack) {
      if (db.open()) {
        await db.transaction("rw?", db.CommutFlghtChanges, async () => {
          await db.CommutFlghtChanges.toArray().then((result) => {
            callBack(result);
          });
        });
      }
    }

  /* -------------------------------- #endregion -------------------------------- */

  /* -------------------------------- #region  Update or Add dexie data -------------------------------- */

  /**
   * @method syncUserData - Syncing user Data
   * @param data - User Details
   */
  public async syncUserData(userData: any, callBack?) {
    try {
      const empNum = userData.EmpNum
        ? userData.EmpNum.toString()
        : userData.EmpId.toString();
      if (db.open()) {
        await db.transaction("rw", db.BidDataDisplay, db.UserData, async () => {
          await db.UserData.where("empId")
            .equals(empNum)
            .first()
            .then(async (syncRecord) => {
              if (syncRecord) {
                //Update AM PM with custom herb time
                if (userData.AppSettings) {
                  userData.AppSettings.amPmTime = userData.AppSettings.amPmTime
                    ? parseInt(userData.AppSettings.amPmTime)
                    : syncRecord.AppSettings
                    ? syncRecord.AppSettings.amPmTime
                    : undefined;
                  userData.AppSettings.cities = userData.AppSettings.cities
                    ? userData.AppSettings.cities
                    : syncRecord.AppSettings
                    ? syncRecord.AppSettings.cities
                    : undefined;
                  userData.AppSettings.isHerbToLocal =
                    userData.AppSettings.isHerbToLocal !== undefined
                      ? userData.AppSettings.isHerbToLocal
                      : syncRecord.AppSettings
                      ? syncRecord.AppSettings.isHerbToLocal
                      : false;
                  userData.AppSettings.isSyncEnabled =
                    userData.AppSettings.isSyncEnabled !== undefined
                      ? userData.AppSettings.isSyncEnabled
                      : syncRecord.AppSettings
                      ? syncRecord.AppSettings.isSyncEnabled
                      : true;
                  userData.AppSettings.selectedCities =
                    userData.AppSettings.selectedCities !== undefined
                      ? userData.AppSettings.selectedCities
                      : syncRecord.AppSettings
                      ? syncRecord.AppSettings.selectedCities
                      : [];
                  db.UserData.where("empId")
                    .equals(empNum)
                    .modify({
                      AppSettings: userData.AppSettings,
                    })
                    .then(function () {
                      if (callBack) callBack(userData);
                    });
                } else {
                  if (syncRecord.AppSettings) {
                    userData.AppSettings = new AppSettings();
                    userData.AppSettings.amPmTime = syncRecord.AppSettings
                      ? syncRecord.AppSettings.amPmTime
                      : undefined;
                    userData.AppSettings.cities = syncRecord.AppSettings
                      ? syncRecord.AppSettings.cities
                      : undefined;
                    userData.AppSettings.isHerbToLocal = syncRecord.AppSettings
                      ? syncRecord.AppSettings.isHerbToLocal
                      : false;
                    userData.AppSettings.isSyncEnabled = syncRecord.AppSettings
                      ? syncRecord.AppSettings.isSyncEnabled
                      : true;
                    userData.AppSettings.selectedCities = syncRecord.AppSettings
                      ? syncRecord.AppSettings.selectedCities
                      : [];
                  }
                  db.UserData.where("empId")
                    .equals(empNum)
                    .modify({
                      IsAuthorized: userData.IsAuthorized,
                      AuthRequestId: userData.AuthRequestId,
                      Message: userData.Message,
                      Type: userData.Type,
                      ExpirationDate: userData.ExpirationDate,
                      CBExpirationDate: userData.CBExpirationDate,
                      WBExpirationDate: userData.WBExpirationDate,
                      IsFree: userData.IsFree,
                      IsYearlySubscribed: userData.IsYearlySubscribed,
                      IsMonthlySubscribed: userData.IsMonthlySubscribed,
                      TopSubscriptionLine: userData.TopSubscriptionLine,
                      SecondSubscriptionLine: userData.SecondSubscriptionLine,
                      ThirdSubscriptionLine: userData.ThirdSubscriptionLine,
                      EmailId: userData.EmailId,
                      AppSettings: userData.AppSettings,
                    })
                    .then(function () {
                      if (callBack) callBack(userData);
                    });
                }
              } else {
                if (userData.AppSettings) {
                  userData.AppSettings.amPmTime = userData.AppSettings
                    ? userData.AppSettings.amPmTime
                    : undefined;
                  userData.AppSettings.cities = userData.AppSettings
                    ? userData.AppSettings.cities
                    : undefined;
                  userData.AppSettings.isHerbToLocal = userData.AppSettings
                    ? userData.AppSettings.isHerbToLocal
                    : false;
                  userData.AppSettings.isSyncEnabled = userData.AppSettings
                    ? userData.AppSettings.isSyncEnabled
                    : true;
                  userData.AppSettings.selectedCities = userData.AppSettings
                    ? userData.AppSettings.selectedCities
                    : [];
                }
                db.UserData.add({
                  empId: empNum,
                  IsAuthorized: userData.IsAuthorized,
                  AuthRequestId: userData.AuthRequestId,
                  Message: userData.Message,
                  Type: userData.Type,
                  ExpirationDate: userData.ExpirationDate,
                  CBExpirationDate: userData.CBExpirationDate,
                  WBExpirationDate: userData.WBExpirationDate,
                  IsFree: userData.IsFree,
                  IsYearlySubscribed: userData.IsYearlySubscribed,
                  IsMonthlySubscribed: userData.IsMonthlySubscribed,
                  TopSubscriptionLine: userData.TopSubscriptionLine,
                  SecondSubscriptionLine: userData.SecondSubscriptionLine,
                  ThirdSubscriptionLine: userData.ThirdSubscriptionLine,
                  EmailId: userData.EmailId,
                  AppSettings: userData.AppSettings,
                }).then(function () {
                  callBack(userData);
                });
              }
              // if (callBack) callBack(true)
            });
        });
      }
    } catch (error) {
      if (callBack) callBack(false);
    }
  }

  /**
   * @method syncColumnDefinitions - Sync Column Definitions
   * @param version - version
   * @param columnDefinitions - Column Definitions
   */
  public async syncColumnDefinitions(
    empNum: string,
    version: string,
    columnDefinitions: string
  ) {
    if (this.dbopen) {
      await db
        .transaction(
          "rw",
          db.BidDataDisplay,
          db.INI_ColumnDefinitions,
          async () => {
            await db.INI_ColumnDefinitions.where("empNum")
              .equals(empNum)
              .first()
              .then(async (syncRecord) => {
                if (syncRecord) {
                  db.INI_ColumnDefinitions.where("empNum")
                    .equals(empNum)
                    .modify({
                      empNum: empNum,
                      version: version,
                      columnDefinitionJsonString: columnDefinitions,
                    })
                    .then(() => {
                      return true;
                    });
                } else {
                  db.INI_ColumnDefinitions.add({
                    empNum: empNum,
                    version: version,
                    columnDefinitionJsonString: columnDefinitions,
                  }).then(() => {
                    return true;
                  });
                }
              });
          }
        )
        .catch((error) => {
          console.log(error);
          //Error
        });
    }
  }

    /**
   * @method syncVacColumnDefinitions - Sync vacation Column Definitions
   * @param version - version
   * @param columnDefinitions - Column Definitions
   */
    public async syncVacColumnDefinitions(
      empNum: string,
      version: string,
      columnDefinitions: string
    ) {
      if (this.dbopen) {
        await db
          .transaction(
            "rw",
            db.BidDataDisplay,
            db.INI_VacColumnDefinitions,
            async () => {
              await db.INI_VacColumnDefinitions.where("empNum")
                .equals(empNum)
                .first()
                .then(async (syncRecord) => {
                  if (syncRecord) {
                    db.INI_VacColumnDefinitions.where("empNum")
                      .equals(empNum)
                      .modify({
                        empNum: empNum,
                        version: version,
                        columnDefinitionJsonString: columnDefinitions,
                      })
                      .then(() => {
                        return true;
                      });
                  } else {
                    db.INI_VacColumnDefinitions.add({
                      empNum: empNum,
                      version: version,
                      columnDefinitionJsonString: columnDefinitions,
                    }).then(() => {
                      return true;
                    });
                  }
                });
            }
          )
          .catch((error) => {
            console.log(error);
            //Error
          });
      }
    }

  /**
   * @method syncCrewbidFlightData for updating or inserting the flight data
   * @param flightDataLzStr as string
   * @param fileName flight data file name as string
   * @param callback for response
   */
  public syncCrewbidFlightData = (
    flightDataLzStr: string,
    fileName: string,
    flightDataVersion: string,
    callback
  ) => {
    let isSaved = false;
    try {
      if (db.open()) {
        db.transaction("rw", db.FlightDataMaster, async () => {
          const data = await db.FlightDataMaster.where("flightDataName")
            .equals(fileName)
            .first();
          if (data) {
            await db.FlightDataMaster.where("flightDataName")
              .equals(fileName)
              .modify({
                flightDataCompressedStr: flightDataLzStr,
                flightDataName: fileName,
                flightDataVersion: flightDataVersion,
              })
              .then(() => {
                isSaved = true;
              })
              .catch(() => {
                // Error in adding the Flight Data
                callback(false);
              });
          } else {
            await db.FlightDataMaster.add({
              flightDataCompressedStr: flightDataLzStr,
              flightDataName: fileName,
              flightDataVersion: flightDataVersion,
            })
              .then(() => {
                isSaved = true;
              })
              .catch(() => {
                // Error in adding the Flight Data
                callback(false);
              });
          }
        })
          .then(() => {
            // Transaction completed successfully
            callback(isSaved);
          })
          .catch(() => {
            // Error in transaction
            callback(false);
          });
      }
    } catch {
      callback(false);
    }
  };

  /**
   * @method syncMonthlyBidData for updating or inserting the bid data
   * @param combinationkey as string
   * @param bidData as bidadata class
   * @param callback for response
   */
  public async syncMonthlyBidData(
    combinationkey,
    bidData: TblBidDataDisplay,
    callback
  ) {
    if (this.dbopen) {
      await db
        .transaction(
          "rw",
          db.BidDataDisplay,
          db.StatePresetVersionInfo,
          db.Preset,
          db.UserData,
          async () => {
            const record = await db.BidDataDisplay.where("fieldId")
              .equals(combinationkey)
              .and((x) => x.EmpNum === bidData.EmpNum)
              .toArray();
            if (record.length > 0) {
              await db.BidDataDisplay.where("fieldId")
                .equals(combinationkey)
                .and((x) => x.EmpNum === bidData.EmpNum)
                .modify({
                  lines: bidData.lines,
                  vacationLines: bidData.vacationLines,
                  vacationEomLines: bidData.vacationEomLines,
                  eomLines: bidData.eomLines,
                  isEBGUser: bidData.isEBGUser,
                  trips: bidData.trips,
                  state: bidData.state,
                  bidPeriodEndDate: bidData.bidPeriodEndDate,
                  bidPeriodStartDate: bidData.bidPeriodStartDate,
                  swaptimizerLines: bidData.swaptimizerLines,
                  swaptimizerServerData: bidData.swaptimizerServerData,
                  isHistoricalBid: bidData.isHistoricalBid,
                  LastSubmitedDate: bidData.LastSubmitedDate
                    ? bidData.LastSubmitedDate
                    : "None",
                  modified: Date.now(),
                  secretEmpNum: bidData.secretEmpNum
                })
                .then(() => {
                  callback(true);
                });
            } else {
              await db.BidDataDisplay.add({
                Domicile: bidData.Domicile,
                Position: bidData.Position,
                Round: bidData.Round,
                Month: bidData.Month,
                Year: bidData.Year,
                fieldId: combinationkey,
                modified: Date.now(),
                created: Date.now(),
                size: "",
                EmpNum: bidData.EmpNum,
                bidPeriodEndDate: bidData.bidPeriodEndDate,
                bidPeriodStartDate: bidData.bidPeriodStartDate,
                lines: bidData.lines,
                trips: bidData.trips,
                state: bidData.state,
                vacationLines: bidData.vacationLines,
                vacationEomLines: bidData.vacationEomLines,
                swaptimizerLines: bidData.swaptimizerLines,
                swaptimizerServerData: bidData.swaptimizerServerData,
                eomLines: bidData.eomLines,
                isEBGUser: bidData.isEBGUser,
                isHistoricalBid: bidData.isHistoricalBid,
                LastSubmitedDate: bidData.LastSubmitedDate,
                secretEmpNum: bidData.secretEmpNum
              }).then(() => {
                callback(true);
              });
            }
          }
        )
        .then(() => {
          console.log("Transaction completed");
        })
        .catch(function (e) {
          callback(false);
          console.error("Generic error: " + e);
        });
    }
  }

  /**
   * @method syncStatePresetVersionInfo for updating of inserting the state and preset version data
   * @param empId is employee id as number
   * @param key is bid id as string
   * @param serverData is server data as TblStatePresetVersionInfo
   * @param callBack is reponse
   */
  public async syncStatePresetVersionInfo(
    empId: number,
    key: string,
    serverData: TblStatePresetVersionInfo,
    callBack
  ) {
    if (db.open()) {
      await db
        .transaction("rw", db.StatePresetVersionInfo, async () => {
          await db.StatePresetVersionInfo.where("empId")
            .equals(empId)
            .and((versionInfo) => versionInfo.fileid == key)
            .first()
            .then(async (syncRecord) => {
              if (syncRecord) {
                await db.StatePresetVersionInfo.where("empId")
                  .equals(empId)
                  .and((versionInfo) => versionInfo.fileid == key)
                  .modify({
                    presetVersion: serverData.presetVersion,
                    stateVersion: serverData.stateVersion,
                    presetLastUpdatedTime: serverData.presetLastUpdatedTime,
                    stateLastUpdatedTime: serverData.stateLastUpdatedTime,
                    isStateModified: serverData.isStateModified,
                    isPresetModified: serverData.isPresetModified,
                  })
                  .then(() => {
                    callBack(true);
                  });
              } else {
                await db.StatePresetVersionInfo.add({
                  empId: empId,
                  presetVersion: serverData.presetVersion,
                  stateVersion: serverData.stateVersion,
                  presetLastUpdatedTime: serverData.presetLastUpdatedTime,
                  stateLastUpdatedTime: serverData.stateLastUpdatedTime,
                  isStateModified: serverData.isStateModified,
                  isPresetModified: serverData.isPresetModified,
                  fileid: key,
                }).then(() => {
                  callBack(true);
                });
              }
            });
        })
        .catch((error) => {
          callBack(false);
        });
    }
  }

  /**
   * @method syncPresetkSetData for saving preset data
   * @param presetData is created preset data
   * @param callBack is reponses
   */
  public async syncPresetSetData(presetData: any, callBack) {
    if (db.open()) {
      await db.transaction("rw", db.Preset, async () => {
        if (presetData.id) {
          await db.Preset.where("empId")
            .equals(presetData.empId)
            .and((data) => data.id == presetData.id)
            .modify({
              presetData: presetData.presetData,
              presetName: presetData.presetName,
            });
        } else {
          await db.Preset.add({
            empId: presetData.empId,
            presetData: presetData.presetData,
            presetName: presetData.presetName,
            position: presetData.position,
          }).then(function (id) {
            callBack(id);
          });
        }
      });
    }
  }

  /**
   * @method syncPresetDataFromServer for saving preset data from server
   * @param empId is employee number as number
   * @param presetListData is preset list data as any
   */
  public async syncPresetDataFromServer(empId: number, presetListData: any) {
    if (db.open()) {
      await db.Preset.clear().then(async () => {
        await db.transaction("rw", db.Preset, async () => {
          const presetServerData = JSON.parse(presetListData);
          presetServerData.forEach(async (ele) => {
            await db.Preset.add({
              empId: empId,
              presetData: ele,
              presetName: ele.presetName,
              position: ele.position,
            });
          });
        });
      });
    }
  }

  /**
   * @method syncBidListData for inserting or updating the bid list data
   * @param bidListData is bid list line data as TblBidList
   */
  public async syncBidListData(bidListData: TblBidList) {
    if (db.open()) {
      await db.transaction("rw", db.BidListData, async () => {
        const record = await db.BidListData.where("empNum")
          .equals(bidListData.empNum)
          .and((x) => x.fieldId == bidListData.fieldId)
          .toArray();
        if (record.length > 0) {
          await db.BidListData.where("empNum")
            .equals(bidListData.empNum)
            .and((x) => x.fieldId == bidListData.fieldId)
            .modify({
              lineData: bidListData.lineData,
            })
            .then(() => {/* */});
        } else {
          await db.BidListData.add({
            empNum: bidListData.empNum,
            fieldId: bidListData.fieldId,
            lineData: bidListData.lineData,
          });
        }
      });
    }
  }

  /**
   * @method syncBidReceipt for inserting or updating the submitted bid data
   * @param submittedBy is submitted by employee number as string
   * @param submittedFor is submitted for employee number as string
   * @param bidReceipt is submitted bid data as string
   * @param submittedTime is submitted bid data time as string
   * @param callBack for response
   */
  public async syncBidReceipt(
    submittedBy: string,
    submittedFor: string,
    bidReceipt: string,
    submittedTime: string,
    callBack
  ) {
    if (this.dbopen) {
      await db
        .transaction("rw", db.UserBidReceipt, async () => {
          const record = await db.UserBidReceipt.where("submittedBy")
            .equals(submittedBy)
            .and((x) => x.submittedFor == submittedFor)
            .toArray();
          if (record.length > 0) {
            await db.UserBidReceipt.where("submittedBy")
              .equals(submittedBy)
              .and((x) => x.submittedFor == submittedFor)
              .modify({ bidReceipt: bidReceipt, submittedTime: submittedTime })
              .then(() => {
                callBack(true);
              });
          } else {
            await db.UserBidReceipt.add({
              submittedBy: submittedBy,
              submittedFor: submittedFor,
              bidReceipt: bidReceipt,
              submittedTime: submittedTime,
            }).then((id) => {
              callBack(true);
            });
          }
        })
        .then(() => {
          console.log("Transaction completed");
        })
        .catch(function (error) {
          callBack(false);
        });
    }
  }

  /**
   * @method syncFAListData for inserting or updating the FA list data
   * @param empId is employee number as string
   * @param faListData is falist data as string
   * @param callBack for response
   */
  public async syncFAListData(empId: string, faListData: FAListData, callBack) {
    if (this.dbopen) {
      await db
        .transaction("rw", db.FAListData, async () => {
          const record = await db.FAListData.where("employeeId")
            .equals(empId)
            .toArray();
          if (record.length > 0) {
            await db.FAListData.where("employeeId")
              .equals(empId)
              .modify({ faList: faListData })
              .then(() => {
                callBack(true);
              });
          } else {
            await db.FAListData.add({
              employeeId: empId,
              faList: faListData,
            }).then((id) => {
              callBack(true);
            });
          }
        })
        .then(() => {
          console.log("Transaction completed");
        })
        .catch(function (error) {
          callBack(false);
        });
    }
  }

  /**
   * @method syncWbidTxtFilesInDexie for inserting or updating the txt files
   * @param Data is bid txt file content
   * @param callBack for response
   */
  public async syncCrewbidTxtFilesInDexie(Data: IBidDataFile, callBack?) {
    if (this.dbopen) {
      db.transaction("rw", db.CrewbidFiles, async function () {
        const file = await db.CrewbidFiles.where("fileName")
          .equals(Data.FileName)
          .toArray();
        if (file.length > 0) {
          await db.CrewbidFiles.where("fileName")
            .equals(Data.FileName)
            .modify({ fileContent: Data.FileContent })
            .then(() => {
              if (callBack) callBack(true);
            });
        } else {
          await db.CrewbidFiles.add({
            fileName: Data.FileName,
            fileContent: Data.FileContent,
          }).then(() => {
            if (callBack) callBack(true);
          });
        }
      });
    }
  }

  /**
   * @method syncBidFiles for syncing the bid files to dexie db
   * @param empId is empoyee number as integer
   * @param key is combination key as string
   * @param bidFiles is needed bid file names
   * @param callBack is response
   */
  public async syncBidFiles(
    empId: number,
    key: string,
    bidFiles: any,
    callBack
  ) {
    if (this.dbopen) {
      db.transaction("rw", db.BidFileNames, async () => {
        const record = await db.BidFileNames.where("fieldId")
          .equals(key)
          .and((x) => x.empId == empId)
          .toArray();
        if (record.length > 0) {
          let existingData = _.cloneDeep(record[0].bidFiles);
          existingData = existingData.filter((x) => x.fileType !== 5);
          existingData = existingData.concat(...bidFiles);
          const uniqueArray = existingData.filter(
            (arr, index, self) =>
              index === self.findIndex((t) => t.fileType === arr.fileType)
          );
          await db.BidFileNames.where("fieldId")
            .equals(key)
            .and((x) => x.empId == empId)
            .modify({ bidFiles: uniqueArray })
            .then(() => {
              callBack(true);
            });
        } else {
          await db.BidFileNames.add({
            empId: empId,
            fieldId: key,
            bidFiles: bidFiles,
          }).then((id) => {
            callBack(true);
          });
        }
      })
        .then(() => {
          console.log("Transaction completed");
        })
        .catch(function (error) {
          callBack(false);
        });
    }
  }

  /**
   * @method syncASortData for inserting or updating the A-Sort Data
   * @param ASortData is A-Sort Data as TblASortData
   */
  public async syncASortData(ASortData: TblASortData) {
    if (db.open()) {
      await db.transaction("rw", db.ASortData, async () => {
        const record = await db.ASortData.where("empNum")
          .equals(ASortData.empNum)
          .and((x) => x.fieldId == ASortData.fieldId)
          .toArray();
        if (record.length > 0) {
          if (ASortData.submittedResult) {
            await db.ASortData.where("empNum")
              .equals(ASortData.empNum)
              .and((x) => x.fieldId == ASortData.fieldId)
              .modify({
                submittedResult: ASortData.submittedResult,
              })
              .then(() => {/* */});
          } else if (ASortData.bidAwards) {
            await db.ASortData.where("empNum")
              .equals(ASortData.empNum)
              .and((x) => x.fieldId == ASortData.fieldId)
              .modify({
                bidAwards: ASortData.bidAwards,
              })
              .then(() => {/* */});
          }
        } else {
          await db.ASortData.add({
            empNum: ASortData.empNum,
            fieldId: ASortData.fieldId,
            submittedResult: ASortData.submittedResult
              ? ASortData.submittedResult
              : undefined,
            bidAwards: ASortData.bidAwards ? ASortData.bidAwards : undefined,
          });
        }
      });
    }
  }

  /**
   * @method syncCommutFlghtChangesInDexie for inserting or Commut diff data into dexie
   * @param Data is bid txt file content
   * @param callBack for response
   */
   public async syncCommutFlghtChangesInDexie(Data: IBidDataFile, callBack?) {
    if (this.dbopen) {
      db.transaction("rw", db.CommutFlghtChanges, async function () {
        const file = await db.CommutFlghtChanges.where("fileName")
          .equals(Data.FileName)
          .toArray();
        if (file.length > 0) {
          await db.CommutFlghtChanges.where("fileName")
            .equals(Data.FileName)
            .modify({ fileContent: Data.FileContent })
            .then(() => {
              if (callBack) callBack(true);
            });
        } else {
          await db.CommutFlghtChanges.add({
            fileName: Data.FileName,
            fileContent: Data.FileContent,
          }).then(() => {
            if (callBack) callBack(true);
          });
        }
      });
    }
  }
  /* -------------------------------- #endregion -------------------------------- */

  /* -------------------------------- #region  Delete dexie data -------------------------------- */

  /**
   * @method deleteLinePrevOperationfor deleting the old bid details exceplt last opened 2 bids
   * @param callback for response
   */
  public async deleteLinePrevOperation(callback) {
    db.transaction("rw", db.BidDataDisplay, async () => {
      const CurrentBidPeriod = moment().add(1, "months").format("MM");
      let Bida = await db.BidDataDisplay.where("modified")
        .notEqual("")
        .toArray();
      Bida = _.filter(Bida, (item) => item.lines !== "");
      Bida = _.filter(Bida, (item) => item.lines !== undefined);
      if (Bida.length > 2) {
        let elementSortedbymodified: TblBidDataDisplay[] = _.sortBy(
          Bida,
          "modified"
        );
        elementSortedbymodified = elementSortedbymodified.reverse();
        if (
          elementSortedbymodified[1].Month === Number.parseInt(CurrentBidPeriod)
        ) {
          // delete elementSortedbyID[2]
          const fieldId = elementSortedbymodified[2].fieldId;
          this.removeBidDataLine(fieldId, () => {
            callback("Deleted.." + fieldId);
          });
        } else {
          // delete elementSortedbymodified[1] data
          const fieldId = elementSortedbymodified[1].fieldId;
          this.removeBidDataLine(fieldId, () => {
            callback("Deleted.." + fieldId);
          });
        }
      } else {
        callback("Deleted Nothing");
      }
    });
  }

  /**
   * @method removeBidDataLine for mark as deleted bid by making line values null
   * @param id is combination key as string
   * @param callback for response
   */
  public async removeBidDataLine(id: string, callback) {
    if (this.dbopen) {
      db.transaction("rw", db.BidDataDisplay, async () => {
        await db.BidDataDisplay.where("fieldId")
          .equals(id)
          .modify({ lines: "" })
          .then(() => {
            callback(true);
          });
      });
    }
  }

  /**
   * @method deleteBidData for deleting bid data
   * @param id is combination key as string
   * @param callback for response
   */
  public async deleteBidData(id: string, callback) {
    if (this.dbopen) {
      db.transaction("rw", db.BidDataDisplay, async () => {
        await db.BidDataDisplay.where("fieldId")
          .equals(id)
          .delete()
          .then(() => {
            callback(true);
          });
      });
    }
  }

  /**
   * @method deletePresetData for deleteing the preset data
   * @param presetData is preset data to delete
   * @param callBack for response
   */
  public async deletePresetData(presetData: TblPreset, callBack) {
    if (this.dbopen) {
      db.transaction("rw", db.Preset, db.StatePresetVersionInfo, async () => {
        await db.Preset.where("empId")
          .equals(presetData.empId)
          .and((data) => data.id == presetData.id)
          .delete()
          .then(() => {
            callBack(true);
          });
      });
    }
  }

  /**
   * @method deleteCommutFlghtChanges for deleting commute flight change json file
   * @param fileName is combination key as string
   * @param callback for response
   */
   public async deleteCommutFlghtChanges(fileName: string, callback) {
    if (this.dbopen) {
      db.transaction("rw", db.CommutFlghtChanges, async () => {
        await db.CommutFlghtChanges.where("fileName")
          .equals(fileName)
          .delete()
          .then(() => {
            callback(true);
          });
      });
    }
  }
  /* -------------------------------- #endregion -------------------------------- */

  /* -------------------------------- #region  Only update dexie data -------------------------------- */
  /**
   * @method updateMonthlyBidDataAfterSync for updating the bid data after sync
   * @param combinationkey as string
   * @param bidData as bidadata class
   * @param callback for response
   */
  public async updateMonthlyBidDataAfterSync(
    combinationkey,
    bidData: TblBidDataDisplay,
    callback
  ) {
    if (this.dbopen) {
      await db
        .transaction(
          "rw",
          db.BidDataDisplay,
          db.StatePresetVersionInfo,
          db.Preset,
          db.BidListData,
          async () => {
            await db.BidDataDisplay.where("fieldId")
              .equals(combinationkey)
              .and((x) => x.EmpNum === bidData.EmpNum)
              .modify({
                lines: bidData.lines,
                vacationLines: bidData.vacationLines,
                vacationEomLines: bidData.vacationEomLines,
                eomLines: bidData.eomLines,
                isEBGUser: bidData.isEBGUser,
                trips: bidData.trips,
                state: bidData.state,
                bidPeriodEndDate: bidData.bidPeriodEndDate,
                bidPeriodStartDate: bidData.bidPeriodStartDate,
                modified: Date.now(),
              })
              .then(() => {
                callback(true);
              });
          }
        )
        .then(() => {
          console.log("Transaction completed");
        })
        .catch(function (e) {
          callback(false);
          console.error("Generic error: " + e);
        });
    }
  }

  /* -------------------------------- #endregion -------------------------------- */
}
